module.exports = __webpack_public_path__ + "img/svg/menu.c6756945e715eda122100a950bc75a1b.svg";